import { ChipTypes } from '@lib/components/Chip/Chip';
import { SsoIntegrationDisplayStatusEnum } from 'graphql-common';

const STATUS_CHIP_MAP: Record<SsoIntegrationDisplayStatusEnum, ChipTypes> = {
  [SsoIntegrationDisplayStatusEnum.Active]: ChipTypes.chipGreen,
  [SsoIntegrationDisplayStatusEnum.Deactivated]: ChipTypes.chipGray,
  [SsoIntegrationDisplayStatusEnum.Misconfigured]: ChipTypes.chipYellow,
};

export default function getSsoDisplayStatusChipType(
  status: SsoIntegrationDisplayStatusEnum,
): ChipTypes {
  return STATUS_CHIP_MAP[status] || ChipTypes.chipGray;
}
